import { useDefaultPartySize } from 'reservations/booking/hooks/useDefaultPartySize';
import {
  BaseFormSchema,
  BookingFormSchema
} from 'reservations/form/components/Form';

export const useDefaultBaseFormValues = (
  defaultFormValues?: BaseFormSchema
) => {
  const partySize = useDefaultPartySize();

  return {
    partySize: defaultFormValues?.partySize ?? partySize,
    date: defaultFormValues?.date ?? new Date(),
    name: defaultFormValues?.name ?? '',
    email: defaultFormValues?.email ?? '',
    specialOccasion: defaultFormValues?.specialOccasion ?? 'None',
    note: defaultFormValues?.note ?? '',
    phone: defaultFormValues?.phone ?? '',
    phoneCode: defaultFormValues?.phoneCode ?? '',
    fullPhoneNumber: defaultFormValues?.fullPhoneNumber ?? '',
    optInMarketingEmail: defaultFormValues?.optInMarketingEmail ?? true,
    optInMarketingSms: defaultFormValues?.optInMarketingSms ?? false,
    savedPaymentMethod: defaultFormValues?.savedPaymentMethod ?? '',
    optInChecklessPayments: defaultFormValues?.optInChecklessPayments ?? false,
    tipPercentage: defaultFormValues?.tipPercentage ?? 0
  };
};

export const useDefaultBookingFormValues = (
  defaultFormValues?: BookingFormSchema
) => ({
  ...useDefaultBaseFormValues(defaultFormValues),
  time: defaultFormValues?.time ?? -1,
  availability: defaultFormValues?.availability ?? null
});
